import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';

// Vue.use(Vuetify, {
//     rtl:true,
//     iconfont: 'mdi',
//     font:{

//     }
// });

Vue.use(Vuetify);

export default new Vuetify({
    rtl: true,
    // theme: {
    // dark: false,
    // themes: {
    //     light: {
    //         primary: '#3f51b5',
    //         secondary: '#b0bec5',
    //         accent: '#8c9eff',
    //         error: '#b71c1c',
    //     }
    // },
    // },
});